<form class="form" (ngSubmit)="onPublishAllLastVersions()">
  <ng-template matStepLabel>System components</ng-template>

  <div class="form-element">
    <button mat-raised-button color="primary" type="submit">Publish All Changes</button>
  </div>
</form>
<button mat-raised-button color="primary" (click)="update()">Update Pump Systems</button>
